var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"default","size":"medium"},nativeOn:{"click":function($event){return _vm.back.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('text.back')))])
}
var staticRenderFns = []

export { render, staticRenderFns }